"use client";
import React from "react";
const FormControlContext = React.createContext({ attributes: {} });
export const Provider = FormControlContext.Provider;
export const useFormControlPrivate = () => React.useContext(FormControlContext);
export const useFormControl = () => {
    const { attributes, required, hasError, disabled } = useFormControlPrivate();
    return { attributes, required, hasError, disabled };
};
